<template>
    <VSelect
        class="formulate-vselect"
        :options="options"
        label="label"
        :reduce="reduceOption"
        :multiple="multiple"
        :clearable="!multiple"
        :placeholder="placeholder"
        :value="context.model"
        @input="onInput"
    ></VSelect>
</template>
<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import VSelect from '@/views/components/VSelect/VSelect.vue';

/**
 * Vue Formulate custom input that renders the application's own VSelect (single or multi) instead of
 * a native <select>. Registered as the `vselect` / `vmultiselect` types. The chosen value(s) are the
 * option value(s); VSelect resolves the visible label from the option list via `reduce`.
 */
@Component({
    components: { VSelect },
})
class FormulateVSelect extends Vue {
    @Prop({ type: Object, required: true }) context;

    get multiple() {
        // The model is initialised to an array for a multiselect field and to null for a single
        // select (see DynamicRequestForm), so the model's shape is the reliable signal — the
        // registered `type` is kept only as a fallback.
        return Array.isArray(this.context.model) || this.context.type === 'vmultiselect';
    }

    get options() {
        return Array.isArray(this.context.options) ? this.context.options : [];
    }

    get placeholder() {
        return this.context.attributes && this.context.attributes.placeholder
            ? this.context.attributes.placeholder
            : 'Выберите значение';
    }

    reduceOption(option) {
        return option.value;
    }

    onInput(value) {
        if (value === undefined || value === null) {
            this.context.model = this.multiple ? [] : null;
            return;
        }

        this.context.model = value;
    }
}

export default FormulateVSelect;
</script>
